export enum CaseMenuAction {
  PREVIEW = 404,
  WITHIN_HIERARCHY_CASE_MAIN = 423,
  SEND_TO_ANYONE_CASE_MAIN = 424,
  SEND_TO_MANY_CASE_MAIN = 406,
  ADD_TO_MAIN_CASE = 861,
  FORWARD_CASE = 418,
  RETURN_TO_INITIATOR_CASE = 208,
  RETURN_TO_SENDER_CASE = 420,
  DISPOSE_CASE = 421,
  AWAIT_CASE = 422,
  RETURN_CASE = 419,
  REASSIGN_CASES = 888891176490,
  MOVE_TO_FOLDER = 79,
  SEND_CASE = 888891176174,
  DELEGATE_PARTIALLY = 888891176491,
  SAVE = 430,
  DELEGATE_PARTIALLY_INSIDE_CASE = 888891176492,
  CLOSE = 546,
  WITHIN_HIERARCHY_INSIDE_CASE = 442,
  SEND_TO_ANYONE_INSIDE_CASE = 443,
  SEND_TO_MANY_INSIDE_CASE = 444,
  SEND_TO_WORKLIST_GROUP = 203,
  FORWARD_INSIDE_CASE = 435,
  RETURN_INSIDE_CASE = 436,
  RETURN_TO_SENDER_INSIDE_CASE = 437,
  RETURN_TO_INITIATOR_INSIDE_CASE = 209,
  CREATEPARTFILES = 860,
  AddtoMainFile = 861,
  DISPOSE_INSIDE_CASE = 440,
  AWAIT_INSIDE_CASE = 441,
  SET_PRIORITY = 111110774,
  VIEW_REMOVE_PRIORITY = 111110775,
  MOVE_TO_WORKLIST_INSIDE = 615,
  APPROVE_INSIDE_CASE = 438,
  NOT_APPROVE_INSIDE_CASE = 439,
}
